<template>
  <div v-if="post" class="post-details-page">
    <divider
      label="blog"
    />

    <div class="main-container">


      <div class="blog-details-hero">
        <div class="asset-container">
          <img v-scroll-animate v-if="post && post.details.featuredImage" :src="post.details.featuredImage"
               alt="post featured image"/>

          <img v-else src="../../assets/defaultPostImage.png" alt="Default Post Image"/>
        </div>

        <div class="logo-container">
          <div class="logo-box">
            <div class="logo-wrapper">
              <img src="../../assets/logo/seu-logo-name.svg" alt="">
            </div>
          </div>
        </div>
      </div>

      <div class="post-info-container">
        <div class="post-info-wrapper">
          <post-info :post="post"/>
        </div>

        <div class="line-row">
          <img class="line-arrow" src="../../assets/icons/arrow-black-left.svg" alt="">
          <div class="line"></div>
          <!--          <seu-button-->
          <!--            :label="$t('common.share')"-->
          <!--            :button-icon-before="shareIcon"-->
          <!--          />-->
          <blog-social-links
            :post="post"
          />
        </div>
      </div>

      <div class="line-separator"></div>


      <div class="post-container">
        <post-details
          v-if="post"
          :post="post"
        />

        <div class="related-blog-posts-section">
          <div class="text-row heading-2" v-html="$t('blog.blog_name', {blog: 'blog'})"></div>
          <div v-if="relatedPosts && relatedPosts.length > 0" class="heading-3-regular">
            {{ $t('blog.related_articles') }}:
          </div>
          <post-grid-card
            v-for="post in relatedPosts"
            :key="post.id"
            :post="post"
            @viewPost="openPostDetailsPage"
          />
        </div>
      </div>

    </div>

  </div>
</template>
<script>
  import {mapGetters, mapState} from "vuex";
  import RelatedPosts from "seu-frontend/modules/blog/components/RelatedPosts.vue";
  import PostDetails from "seu-frontend/modules/blog/components/PostDetails.vue";
  import PostGridCard from "../../modules/blog/components/PostGridCard";
  import PostInfo from "/seu-frontend/modules/blog/components/PostInfo";
  import SeuButton from "/seu-frontend/components/SeuButton";
  import DividerSection from "/seu-frontend/sections/general/DividerSection";
  import BlogSocialLinks from "seu-frontend/modules/blog/components/BlogSocialLinks.vue";
  import Divider from "/seu-frontend/components/section-fields/Divider";

  export default {
    name: "PostDetailsPage",
    components: {
      BlogSocialLinks,
      Divider,
      DividerSection,
      SeuButton,
      PostInfo,
      PostGridCard,
      PostDetails,
      RelatedPosts
    },
    props: {
      slug: {
        type: String,
        required: true
      },
      lang: {
        type: String
      }
    },
    data: () => ({
      shareIcon: require('../../assets/icons/share-icon.svg')
    }),
    computed: {
      ...mapState('post', ['relatedPosts']),
      ...mapGetters('post', ["getBySlug"]),

      post() {
        return this.getBySlug(this.slug)
      },
      ...mapState({
        defaultLanguage: state => state.defaultLanguage.toLowerCase(),
      }),
    },
    methods: {
      listRelatedPosts(id) {
        return this.$store.dispatch('post/listRelatedPosts', {
          id: id
        })
      },
      getPostDetails() {
        return this.$store.dispatch('post/getPost', {
            slug: this.slug
          })
          .then(post => this.listRelatedPosts(post.id))
      },
      openPostDetailsPage(post) {
        this.$router.push({
          name: "PostDetailsPage",
          params: {
            slug: post.details.slug,
            lang: this.$route.params.lang
          }
        })
      },
    },
    created() {
      return this.getPostDetails()
    },
    beforeRouteUpdate(to, from, next) {
      const lang = to.params.lang ?  to.params.lang: this.defaultLanguage;
      const translation = this.post.translations.find(tr => tr.lang.toLowerCase()===lang);
      if (!translation) {
        next({name:"PostsPage"})
      } else if (translation.slug===to.params.slug) {
        next()
      } else {
        to.params.slug
        next({
          ...to,
          params: {
            ...to.params,
            slug: translation.slug
          }
        })
      }

    },
    metaInfo() {
      if (!this.post) {
        return {}
      }
      return {
        title: this.post.details.seoSettings.title,
        meta: [
          ...this.post.details.seoSettings.description ? [{
            vmid: 'description',
            name: 'description',
            content: this.post.details.seoSettings.description,
          }]:[],
          ...this.post.details.metaTags.map(metaTag => ({
            [metaTag.type]: metaTag.value,
            content: metaTag.content,
            vmid: metaTag.type
          })),
          {
            name: 'robots',
            vmid: 'robots',
            content: `${this.post.details.seoSettings.showInSearchResult ? 'index':'noindex'}, ${this.post.details.seoSettings.enableLinkFollow ? 'follow':'nofollow'}`
          }
        ]
      }
    }
  }
</script>
<style lang="scss">
  @import "PostDetailsPage";
</style>
